import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { Trash2 } from "lucide-react";

const COLOR_OPTIONS = [
  { value: "#6366f1", label: "Indaco" },
  { value: "#ef4444", label: "Rosso" },
  { value: "#f59e0b", label: "Arancione" },
  { value: "#10b981", label: "Verde" },
  { value: "#3b82f6", label: "Blu" },
  { value: "#8b5cf6", label: "Viola" },
  { value: "#ec4899", label: "Rosa" },
  { value: "#6b7280", label: "Grigio" },
];

export function ReminderFormDialog({ dialog, setDialog, form, setForm, onSave, onDelete }) {
  const update = (field, value) => setForm(prev => ({ ...prev, [field]: value }));

  return (
    <Dialog open={dialog.open} onOpenChange={(open) => setDialog({ ...dialog, open })}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{dialog.reminder ? "Modifica Promemoria" : "Nuovo Promemoria"}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label>Titolo *</Label>
            <Input value={form.titolo} onChange={(e) => update('titolo', e.target.value)} placeholder="Titolo del promemoria" data-testid="reminder-title-input" />
          </div>
          <div className="space-y-2">
            <Label>Descrizione</Label>
            <Textarea value={form.descrizione} onChange={(e) => update('descrizione', e.target.value)} placeholder="Note aggiuntive..." rows={2} />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label>Data *</Label>
              <Input type="date" value={form.data} onChange={(e) => update('data', e.target.value)} />
            </div>
            <div className="space-y-2">
              <Label>Ora (opzionale)</Label>
              <Input type="time" value={form.ora} onChange={(e) => update('ora', e.target.value)} />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label>Colore</Label>
              <Select value={form.colore} onValueChange={(v) => update('colore', v)}>
                <SelectTrigger>
                  <SelectValue>
                    <div className="flex items-center gap-2">
                      <div className="w-4 h-4 rounded" style={{ backgroundColor: form.colore }} />
                      {COLOR_OPTIONS.find(c => c.value === form.colore)?.label || "Colore"}
                    </div>
                  </SelectValue>
                </SelectTrigger>
                <SelectContent>
                  {COLOR_OPTIONS.map(c => (
                    <SelectItem key={c.value} value={c.value}>
                      <div className="flex items-center gap-2">
                        <div className="w-4 h-4 rounded" style={{ backgroundColor: c.value }} />
                        {c.label}
                      </div>
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            <div className="space-y-2">
              <Label>Ripeti</Label>
              <Select value={form.ripeti || "none"} onValueChange={(v) => update('ripeti', v === "none" ? "" : v)}>
                <SelectTrigger><SelectValue placeholder="Non ripetere" /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="none">Non ripetere</SelectItem>
                  <SelectItem value="giornaliero">Giornaliero</SelectItem>
                  <SelectItem value="settimanale">Settimanale</SelectItem>
                  <SelectItem value="mensile">Mensile</SelectItem>
                  <SelectItem value="annuale">Annuale</SelectItem>
                </SelectContent>
              </Select>
            </div>
          </div>
        </div>
        <DialogFooter>
          {dialog.reminder && (
            <Button variant="destructive" onClick={() => onDelete(dialog.reminder.id)} className="mr-auto">
              <Trash2 className="h-4 w-4 mr-2" /> Elimina
            </Button>
          )}
          <Button variant="outline" onClick={() => setDialog({ open: false, reminder: null })}>Annulla</Button>
          <Button onClick={onSave} data-testid="save-reminder-btn">
            {dialog.reminder ? "Salva Modifiche" : "Crea Promemoria"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
